import React from "react";
import classNames from "classnames";
import {
  Button as UiButton,
  ButtonProps as UiButtonProps,
} from "@stemscopes/ui";
import styles from "./Button.module.css";

interface ButtonProps extends UiButtonProps {
  colorScheme?: "primary" | "warning" | "danger" | "info" | "basic" | "success";
  iconAuto?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  colorScheme = "primary",
  iconAuto = false,
  className = "",
  prefixClassName = "",
  suffixClassName = "",
  variant = "primary",
  size = "medium",
  ...rest
}) => (
  <UiButton
    {...rest}
    variant={variant}
    size={size}
    prefixClassName={classNames(prefixClassName, {
      [styles.iconAuto]: iconAuto,
    })}
    suffixClassName={classNames(suffixClassName, {
      [styles.iconAuto]: iconAuto,
    })}
    className={classNames(className, styles.wrapper, {
      [styles.small]: size === "small",
      [styles.medium]: size === "medium",
      [styles.large]: size === "large",
      [styles.primary]: variant === "primary",
      [styles.secondary]: variant === "secondary",
      [styles.clear]: variant === "clear",
      [styles.primaryWarning]:
        colorScheme === "warning" && variant === "primary",
      [styles.secondaryWarning]:
        colorScheme === "warning" && variant === "secondary",
      [styles.clearWarning]: colorScheme === "warning" && variant === "clear",
      [styles.primaryDanger]: colorScheme === "danger" && variant === "primary",
      [styles.secondaryDanger]:
        colorScheme === "danger" && variant === "secondary",
      [styles.clearDanger]: colorScheme === "danger" && variant === "clear",
      [styles.primaryInfo]: colorScheme === "info" && variant === "primary",
      [styles.secondaryInfo]: colorScheme === "info" && variant === "secondary",
      [styles.clearInfo]: colorScheme === "info" && variant === "clear",
      [styles.primarySuccess]:
        colorScheme === "success" && variant === "primary",
      [styles.secondarySuccess]:
        colorScheme === "success" && variant === "secondary",
      [styles.clearSuccess]: colorScheme === "success" && variant === "clear",
      [styles.primaryBasic]: colorScheme === "basic" && variant === "primary",
      [styles.secondaryBasic]:
        colorScheme === "basic" && variant === "secondary",
      [styles.clearBasic]: colorScheme === "basic" && variant === "clear",
      [styles.primarySuccess]:
        colorScheme === "success" && variant === "primary",
      [styles.secondarySuccess]:
        colorScheme === "success" && variant === "secondary",
      [styles.clearSuccess]: colorScheme === "success" && variant === "clear",
    })}
  />
);

export default Button;
